"use client";
import React from "react";
import PropTypes from "prop-types";
import MobileDrawer from "@/components/shared/MobileDrawerWrapper";

import "@/components/shared/FullscreenMapAndDrawer.css";

const FullscreenMapAndDrawer = ({
  mapComponent,
  show,
  drawerComponent,
  closeComponent,
  onDrawerClose
}) => {
  if (!show) return null; // If `show` is false, render nothing

  const styles = {
    container: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100dvh", // Full screen including dynamic viewport height
      zIndex: 1030 // Ensure it overlays everything else
    },
    map: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 1 // Map layer behind other components
    },
    closeButton: {
      position: "absolute",
      bottom: "1rem",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 2 // Close button above everything
    }
  };

  return (
    <div style={styles.container}>
      {/* Map Layer */}
      <div style={styles.map}>{mapComponent}</div>

      {/* Drawer Layer */}
      {drawerComponent && (
        <MobileDrawer
          open={!!drawerComponent} // Open the drawer if content is provided
          direction="bottom" // Drawer slides up from the bottom
          // modalElementClass="drawer-modal"
          containerElementClass="drawer-container"
          onRequestClose={() => {}} // Optional: Handle closing logic if needed
        >
          <div className="drawer-content">
            <div className={"close-button clickable"} onClick={onDrawerClose}>
              <span className="material-icons">close</span>
            </div>
            {drawerComponent}
          </div>
        </MobileDrawer>
      )}

      {/* Close Button */}
      <div style={styles.closeButton}>{closeComponent}</div>
    </div>
  );
};

FullscreenMapAndDrawer.propTypes = {
  mapComponent: PropTypes.node.isRequired, // React Node for the map
  show: PropTypes.bool.isRequired, // Determines visibility
  drawerComponent: PropTypes.node, // React Node for the drawer content
  closeComponent: PropTypes.node.isRequired // React Node for the close button
};

export default FullscreenMapAndDrawer;
